<template>
  <RevInputSelect
    id="market"
    :label="i18n(translations.label)"
    :model-value
    :options
    @update:model-value="(value) => emit('update:modelValue', value)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputSelect } from '@ds/components/InputSelect'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './SelectMarket.translations'

const i18n = useI18n()

defineProps<{ modelValue: string }>()
const emit = defineEmits(['update:modelValue'])

const optionAll = { label: i18n(translations.all), value: '' }

const sellerStore = useSellerInfoStore()

const options = computed(() => [
  optionAll,
  ...sellerStore.activeMarkets.map((market) => ({
    label: i18n.country(market),
    value: market,
  })),
])
</script>
